Object.defineProperty(exports, '__esModule', { value: true });

var enums_swipeEnums = require('../enums/swipeEnums.js');

var horizontalDirections = [enums_swipeEnums.SwipeDirection.Left, enums_swipeEnums.SwipeDirection.Right];

exports.horizontalDirections = horizontalDirections;
